module.exports = __webpack_public_path__ + "media/images/upload_youtube_drive-3947eabd.png";